<template>
  <div class="col-span-2 sm:col-span-1">
    <div class="mt-0 sm:mt-2 relative">
      <contact-form-svg-wrapper :active="active">
        <phone-icon-path/>
      </contact-form-svg-wrapper>
      <input
          @focus="active = name"
          @blur="active = undefined"
          v-model="input"
          id="phone_number"
          placeholder="Telefon"
          class="bg-secondary-gray focus:placeholder-transparent placeholder-primary-gray text-base text-primary-black outline-none rounded-md shadow-sm focus:shadow-green form-input py-2 pl-10 pr-6 block w-full transition ease-out duration-700"
      />
    </div>
  </div>
</template>

<script>
import contactFormFields from "@/mixins/contactFormFields";
import PhoneIconPath from "@/components/utils/icon-paths/PhoneIconPath";

export default {
  name: "ContactFormPhone",
  mixins: [contactFormFields],
  components: {
    PhoneIconPath
  },
  data: () => ({
    name: 'phoneNumber'
  })
}
</script>

<style scoped>

</style>
